












import { Component, Vue } from 'vue-property-decorator';
import { State, Action } from 'vuex-class';
import firebase from 'firebase';
import { User } from '@/models/user';
import Users from '@/components/users/Users.vue';

@Component
export default class Setup extends Vue {
  private activeTab = '/setup/users';

    private tabs = [
        {
            id: 1,
            name: 'Users',
            route: '/setup/users',
        },
        {
            id: 2,
            name: 'Farms',
            route: '/setup/farms',
        },
        {
            id: 3,
            name: 'Crops',
            route: '/setup/crops',
        },
        {
            id: 4,
            name: 'Crop Codes',
            route: '/setup/crop-codes',
        },
        {
            id: 5,
            name: 'Templates',
            route: '/setup/templates',
        },
    ];
}
